import React, { useState } from 'react';
import {
	IplpTemplate,
	useDeleteIplpTemplateMutation,
} from '../../../../../graphql/graphql';
import LinkButton from '../../../../../Components/Button/LinkButton';
import { Theme } from '../../../../../Enums/Theme.enum';
import RemoveButton from '../../../../../Components/Button/RemoveButton';
// @ts-ignore
import styles from './IPLPTemplateListItem.module.scss';
import IPLPTemplateUpdateModal from '../IPLPTemplateUpdate/IPLPTemplateUpdateModal';
import useApiClient from '../../../../Base/Hooks/useApiClient';

interface Props {
	item: IplpTemplate;
	onSelect: (item: IplpTemplate) => void;
	onUpdate: () => void;
	onDelete: () => void;
}

const IPLPTemplateListItem: React.FC<Props> = ({
	item,
	onUpdate,
	onDelete,
	onSelect,
}) => {
	const [isUpdateOpen, setIsUpdateOpen] = useState(false);
	const [deleteIPLPTemplate] = useDeleteIplpTemplateMutation();
	const { displayGQLError } = useApiClient();

	const handleOnDelete = async () => {
		const response = await deleteIPLPTemplate({
			id: item.id,
		});

		displayGQLError(response);

		if ('data' in response) {
			onDelete();
		}
	};

	const handleOnItemUpdate = () => {
		setIsUpdateOpen(false);
		onUpdate();
	};

	return (
		<>
			<div className={styles.wrapper}>
				<div className={styles.content}>
					<div>{item.name}</div>
				</div>
				<div className={styles.controls}>
					<LinkButton
						title='component.IPLPTemplateListItem.select'
						theme={Theme.BLUE}
						onClick={() => onSelect(item)}
					/>
					<LinkButton
						title='component.IPLPTemplateListItem.edit'
						theme={Theme.BLUE}
						onClick={() => setIsUpdateOpen(true)}
					/>
					<RemoveButton
						title='component.IPLPTemplateListItem.delete'
						onClick={handleOnDelete}
					/>
				</div>
			</div>
			{isUpdateOpen && (
				<IPLPTemplateUpdateModal
					isOpen
					onClose={() => setIsUpdateOpen(false)}
					item={item}
					onUpdate={handleOnItemUpdate}
				/>
			)}
		</>
	);
};

export default IPLPTemplateListItem;
